<template lang="html">
</template>

<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: 'home',
  mounted() {
    if (this.loginSuccess) {
      if (this.user.ccadmEnabled) 
        this.$router.push("/interface_labels?action=search&activeGroup=Main Window")
      else if (this.user.priceConfEnabled) 
        this.$router.push("price_configurator")
      else if (this.user.packConfEnabled) 
        this.$router.push("pack_configurator")
      else {
        this.$bvModal.msgBoxOk("User not enabled!", {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          }).then(() => {
        this.login_error({username: this.user.username})
        this.$router.push("login")})
      }
    }
  },
  computed: {
    ...mapState([
      'loginSuccess',
      'user'
    ])
  },
  methods: {
    ...mapActions([
      'login_error'
    ])
  }
}
</script>

<style scoped lang="scss">
</style>
